import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { sendData } from "../../analytics/sendData";
import { config } from "./../../constants/domainConfig";
import { FormattedMessage } from "react-intl";
import { isGameverse, isGamiclub } from "../../constants/isGamiclub";
import {
  isFunzarena,
  isGamelords,
  isPlaynixzone,
} from "../../constants/productCondition";
import { isTheGamingClubs } from "../../constants/isTheGamingClubs";

class Terms extends Component {
  componentDidMount() {
    sendData("", "", "", "viewed", { page: "terms-&-conditions" });
    window.scrollTo(0, 0);
  }

  render() {
    if (config.subDomain === "rs") {
      return (
        <section className="terms">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="terms-title-wrap">
                  <h2 className="terms-section-title">Услови коришћења</h2>
                  <p
                    className="terms-para"
                    style={{ textAlign: "center", fontSize: "14px" }}
                  >
                    Посетилац - представља особу која посећује веб локацију која
                    рекламира услугу или другу страницу за оглашавање (штампа,
                    ТВ и радио).
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <p className="terms-para-head">Ток претплате:</p>
                <p className="terms-para-list">
                  - крајњи корисник треба да унесе свој број мобилног телефона
                  на одредишној страници
                </p>
                <p className="terms-para-list">
                  - крајњи корисник ће затим добити јединствени једнократни пин
                </p>
                <p className="terms-para-list">
                  - након што унесе једнократни пин на одредишну страницу,
                  корисник се пријављује на нашу услугу
                </p>
                <p className="terms-para-list">
                  - крајњи корисник ће добити поруку добродошлице и одмах затим
                  поруку ка садржају, како би могао да ужива у нашем производу
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">1. ИЗЈАВА О ПРИВАТНОСТИ</h6>
                <p className="terms-para">
                  Заштита личних података корисника за нас је важна. За понуђене
                  услуге прикупљамо, обрађујемо или користимо личне податке
                  корисника, као што је описано у наредним чланцима. Електронски
                  подаци су подаци корисника који услугу активирају оглашавањем
                  на Интернету или активирањем путем Интернета, а то су ИП
                  адреса корисника, корисник е-поште, оперативни систем,
                  прегледане странице у оквиру оглашавања услуге.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">2. КОРИСНИ ПОСЈЕТНИЦИ</h6>
                <p className="terms-para">
                  Подаци које посетилац (особа која није активирала услугу)
                  произвољно оставља на рекламним локацијама, укључујући
                  телефонски број, адресу е-поште и друге личне и електронске
                  податке, подаци су за које пружалац услуге има право да
                  користи у оквиру својих пројеката. Посетилац се такође слаже
                  да пружалац услуга може користити своје бројеве мобилних
                  телефона у својим маркетиншким активностима.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">3. Приступ услузи</h6>
                <p className="terms-para-head">3.1 </p>
                <p className="terms-para">
                  Организатор услуге Организатор и добављач услуга је компанија
                  Интер Sam Media BV. Коришћењем ове услуге корисник потврђује
                  да је прочитао и разумео услове коришћења услуге и у
                  потпуности се са њима слаже.
                </p>
                <p className="terms-para-head">3.2. Опис услуге</p>
                <p className="terms-para">
                  Сервис могу да користе корисници мобилних оператера МТС,
                  Yеттел, A1 који имају 18 или више година. слуга је забавна и
                  пружа портал са најбољим хтмл5 играма, могућношћу скидања на
                  андроид уређајима те забавни видео садржај, доступних на вашем
                  мобилном уређају, са неограниченим приступом у току ваше
                  онлајн претплате..
                </p>
                <p className="terms-para-head">
                  3.3. Опис функционисања услуге
                </p>
                <p className="terms-para">
                  Да би учествовао у услузи, корисник прихвата услове услуге и
                  претплаћује се на услугу.
                </p>
                <p className="terms-para-head">3.4. Плаћање</p>
                <p className="terms-para">
                  услуга Услуга се плаћа. Плаћање се врши преко мобилног
                  оператера. Корисницима свих мобилних провајдера наплаћује се
                  свака послата порука осим системске поруке. Пружалац услуга
                  има право промене цена својих услуга, али је дужан да о томе
                  обавести кориснике на свим местима где су постављени услови и
                  упутства за коришћење услуга. Ако провајдер сервиса промени
                  цену услуге током периода услуге, корисник остаје корисник
                  услуге док се не одјави из услуге.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">4. ОПШТА ПРАВИЛА</h6>
                <p className="terms-para-head">4.1. Опис и сврха услуге</p>
                <p className="terms-para">
                  Интернет, штампа, ТВ и радио медији место су за оглашавање
                  забавних услуга путем мобилних телефона путем коришћења СМС
                  порука. Сврха услуге је искључиво у забаву. Пружалац услуга не
                  утиче на кориснике и операторе, а нарочито на СМС комуникацију
                  тамо где се не може потврдити да су информације које размењују
                  корисници и оператери тачне.
                </p>
                <p className="terms-para-head">
                  4.2. Доступност услуге Добављач услуга
                </p>
                <p className="terms-para">
                  покушава максимално повећати расположивост услуге. Због
                  техничких карактеристика интернетске везе и мобилне
                  телефоније, на које добављач услуга не утјече, може доћи до
                  повремених прекида у преносу података - раду услуге. Провајдер
                  сервиса не може гарантовати доступност и доступност услуге.
                </p>
                <p className="terms-para-head">
                  4.3. Технички услови за коришћење услуге
                </p>
                <p className="terms-para">
                  Корисник мора да осигура одржавање и подешавања свог мобилног
                  телефона. У овом случају, пружалац услуга није дужан да пружа
                  техничку подршку. Да би користио услугу, корисник мора
                  користити функционални мобилни телефон и имати ваљану везу
                  (сигнал) на свом мобилном телефону. Без ових услова употреба
                  услуге није могућа. Корисник је искључиво одговоран за пружање
                  техничких услова. Пружалац услуге није одговоран ако корисник
                  не може да користи услугу због ограничења свог провајдера.
                </p>
                <p className="terms-para-head">
                  4.4. Трошкови коришћења услуге Коришћењем
                </p>
                <p className="terms-para">
                  услуге, корисник пристаје на настале трошкове јер је
                  информисан о цени услуге у складу са правилима које прописују
                  закон и мобилни провајдери. С обзиром на то да су трошкови
                  исказани на сајтовима за оглашавање, као и у условима и
                  условима коришћења, корисник прихвата обавезу да нема право да
                  захтева настале трошкове, као и да надокнади трошкове ако није
                  добио одговор на поруку.
                </p>
                <p className="terms-para-head">4.5. Промена услова коришћења</p>
                <p className="terms-para">
                  Пружалац услуге задржава право да промени услове уговора у
                  било ком тренутку у будућности. Након промена услова коришћења
                  услуге, ако је корисник претходно пристао на услове, а након
                  што промена није, он се може одјавити у складу са
                  функционисањем услуге. Пружалац услуга није дужан да
                  обавештава кориснике о промени услова.
                </p>
                <p className="terms-para-head">
                  4.6. Осигурање / накнада гаранције
                </p>
                <p className="terms-para">
                  Компанија, њени директори, службеници, запослени, добављачи и
                  агенти се одричу сваке одговорности за било какву штету
                  насталу употребом Услуга. Изричито разумете и пристајете да
                  Услуге пружате на начин "какав јесте" и "како је доступан" без
                  икаквих гаранција. Стране добављача изричито се одричу у
                  највећој мери допуштеној законом свим гаранцијама, било
                  изричитим или имплицираним, одређеним законом или на неки
                  други начин, у вези са услугама, укључујући, без ограничења,
                  подразумеване услове продаје, власништва и продаје робе и
                  имовине, као и наменску функцију и кршење ауторских права.
                  Стране у уговору се одричу сваке гаранције у погледу
                  сигурности, поузданости, благовремености и перформанси услуга.
                  Уговорне стране не гарантују да ће Услуге испунити ваше
                  захтеве или да ће услу вета или информација, било да су усмене
                  или писмене, добијене од нас или путем наших услуга, неће се
                  створити гаранција која није овде изричито наведена. Не можете
                  се ослонити на такве информације или савете. Разумете и
                  пристајете на преузимање и / или коришћење Услуга, садржаја,
                  софтвера и веб локација на сопствени ризик и ризик и да ћете
                  бити једини одговорни за било какво оштећење рачунарског
                  система, мобилног телефона или губитак података који су
                  последица. коришћење услуга. Осим у надлежностима у којима су
                  ове одредбе ограничене, слажете се да је целокупна одговорност
                  Компаније према вама или било којој трећој страни, као и за
                  ваш или ексклузивни лек било које треће стране, законски, у
                  капиталу или на други начин у вези са услугама пруженим овим
                  споразумом и / или било каквим кршењем овог споразума,
                  ограничен је искључиво на износ који сте платили за такве
                  услуге током трајања овог уговора. Осим у јурисдикцијама у
                  којима су такве одредбе ограничене, стране уговорнице које су
                  стицале неће бити одговорне за било какву директну,
                  индиректну, случајну, посебну, узорну, кривичну, трећу или
                  последичну штету (укључујући штету због губитка пословне
                  добити, прекида пословања, губитка пословних информација и
                  слично) проистекле из ваше употребе, злоупотребе или
                  немогућности коришћења Услуга, Садржаја, Софтвера и Веб
                  локације, чак и ако је Компанија обавештена о могућности такве
                  штете, у мери у којој држава не дозвољава искључење или
                  ограничење одговорности како је наведено у овом документу. ,
                  одговорност компаније је ограничена на ниво дозвољен законом у
                  тој земљи. Сагласни сте да заштитите Компанију и њене
                  родитеље, чланове, подружнице, подружнице, пружаоце услуга,
                  предузетнике, агенте, даваоце лиценце, службенике, директоре,
                  акционаре и запослене од губитка, одговорности, захтева, тужбе
                  или захтева, укључујући разумне адвокатске накнаде, направљене
                  од било које треће стране која произилази из или у вези са (а)
                  вашом употребом Услуга и (б) кршењем од вас или ваших
                  представника и гаранцијама утврђеним у овим Условима. Платит
                  ћете и све трошкове, одштету и трошкове одштете, укључујући
                  без ограничења, разумне одветничке накнаде и трошкове
                  додијељене за плаћање или на које је Компанија накнађена у
                  вези с било којом таквом тужбом, парницом, поступком,
                  потраживањем или други поступак.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">5. ПРИВАТНОСТ</h6>
                <p className="terms-para-head">
                  5.1. Изјава о заштити приватности
                </p>
                <p className="terms-para">
                  Заштита личних података корисника за нас је важна. Све
                  информације које прикупљамо остављају кориснику произвољно и
                  не морају их остављати.
                </p>
                <p className="terms-para-head">5.2.</p>
                <p className="terms-para">
                  Корисничке информације о услугама {"<бр>"} За потребе
                  функционисања услуге потребан нам је број мобилног телефона
                  корисника да бисмо омогућили СМС поруке. Подаци који се
                  размењују у оквиру услуге све су личне и опште информације
                  које корисник размењује у сервису слањем смс порука. У оквиру
                  важећег законодавства, можемо истраживати корисничке податке у
                  рекламне сврхе, истраживање тржишта, за побољшање наших услуга
                  и за промоцију других услуга које пружа пружалац услуга.
                </p>
                <p className="terms-para-head">5.3.</p>
                <p className="terms-para">
                  Пренос података посетилаца и корисника и снимање у интерном
                  систему у статистичке сврхе Размена података у услузи
                  остварује се путем СМС порука, као и позивима фиксног или
                  мобилног провајдера. Размена позива односи се искључиво на
                  захтев корисника да се одјави, као и на пружање техничке
                  подршке за активирање или одјаву претплате на услугу (али не и
                  информације о кориснику, провајдеру услуге итд.).
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      );
    } else if (config.subDomain === "pl" && isFunzarena) {
      return (
        <section className="terms">
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">§ 1 Postanowienia ogólne</h6>

                <p className="terms-para">
                  1. Niniejszy regulamin (dalej: „Regulamin”) określa zasady
                  dostępu do serwisu FUNZ ARENA oferowanego przez SAM MEDIA,
                  siedziba: Van Diemenstraat 356, 1013CN Amsterdam, kontakt w
                  sprawie reklamacji: reklamacje@teleaudio.pl, tel. 22 244 40 22
                  (9:30–17:00).
                </p>

                <p className="terms-para">
                  2. Usługi realizowane w ramach Serwisu FUNZ ARENA są płatne na
                  warunkach przewidzianych w Regulaminie.
                </p>

                <p className="terms-para">
                  3. Każdy użytkownik zobowiązany jest do zapoznania się z
                  Regulaminem przed skorzystaniem z Usługi. Korzystanie z Usługi
                  jest możliwe wyłącznie po zaakceptowaniu Regulaminu.
                </p>

                <p className="terms-para">
                  4. Z Usług (zdefiniowanych poniżej) mogą korzystać Użytkownicy
                  sieci następujących operatorów: Orange Polska S.A. (ORANGE),
                  T-Mobile Polska S.A. (T-MOBILE), P4 Sp. z o.o. (PLAY) oraz
                  Polkomtel Sp. z o.o. (PLUS).
                </p>

                <p className="terms-para">
                  5. Użytkownicy zobowiązani są do korzystania z Usługi oraz z
                  Serwisu zgodnie z obowiązującym na terytorium Rzeczypospolitej
                  Polskiej prawem oraz postanowieniami niniejszego Regulaminu.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">§ 2 ZASADY KORZYSTANIA Z USŁUG</h6>

                <p className="terms-para">
                  1. Szczegółowy opis Usług oferowanych przez Organizatora wraz
                  z ich cenami dostępny jest w Serwisie:
                  https://pl.funzarena.com/#/welcome?uid=fdf098fcc6
                </p>

                <p className="terms-para">
                  2. Organizator ma prawo dokonywać aktualizacji oraz rozwoju
                  funkcjonalności Usług i Serwisu.
                </p>

                <p className="terms-para">
                  3. Usługi w Serwisie są płatne. Usługę można zakupić wyłącznie
                  poprzez przesłanie wiadomości SMS o treści GAME, RACE, ARENA
                  lub GRY na numer 92505. Koszt: 25 zł netto (30,75 zł brutto)
                  za dostęp na 30 dni lub inny, wskazany w materiałach
                  promocyjnych.
                </p>

                <p className="terms-para">
                  4. Przed dokonaniem płatności SMS Klient powinien upewnić się:
                </p>

                <ul>
                  <li>
                    <p className="terms-para">
                      a. Czy w telefonie komórkowym znajduje się wystarczająca
                      ilość wolnej pamięci niezbędnej do odczytania wybranej
                      treści. W przypadku niewystarczającej ilości pamięci treść
                      zostanie zamówiona i opłacona, jednak Klient nie będzie
                      mógł jej odczytać;
                    </p>
                  </li>
                  <li>
                    <p className="terms-para">
                      b. Czy posiadany telefon jest poprawnie skonfigurowany i
                      umożliwia odbieranie wiadomości SMS. Informacje dotyczące
                      konfiguracji telefonu Klient może uzyskać, kontaktując się
                      ze swoim Operatorem;
                    </p>
                  </li>
                  <li>
                    <p className="terms-para">
                      c. Czy dana treść jest oferowana dla posiadanego modelu
                      telefonu komórkowego.
                    </p>
                  </li>
                </ul>

                <p className="terms-para">
                  5. Korzystanie z Usługi wymaga dostępu do sieci Internet.
                  Opłaty za Usługę nie obejmują kosztów transmisji danych, które
                  Użytkownik ponosi zgodnie z taryfą Operatora.
                </p>

                <p className="terms-para">
                  6. Usługi dostępne są na terenie Rzeczpospolitej Polskiej.
                </p>

                <p className="terms-para">
                  7. Użytkownicy są uprawnieni do przenoszenia Usług oraz
                  korzystania z nich podczas czasowego pobytu na terenie Unii
                  Europejskiej lub Europejskiego Obszaru Gospodarczego, po
                  pozytywnej weryfikacji rzeczywistego i stałego miejsca
                  zamieszkania na terytorium Rzeczpospolitej Polskiej.
                </p>

                <p className="terms-para">
                  8. Usługa świadczona w ramach przenoszenia Usług podczas
                  czasowego pobytu za granicą jest realizowana w takim samym
                  zakresie i na tych samych warunkach jak w Polsce.
                </p>

                <p className="terms-para">
                  9. Zawarcie Umowy następuje z chwilą rozpoczęcia rozmowy
                  telefonicznej w ramach Usługi lub z chwilą wysłania przez
                  Użytkownika SMS-a na numer podany w Regulaminie.
                </p>

                <p className="terms-para">
                  10. Wysyłając SMS-a, Użytkownik wyraża zgodę na realizację
                  Usługi przed upływem terminu do odstąpienia od Umowy.
                </p>

                <p className="terms-para">
                  11. Użytkownikowi nie przysługuje prawo odstąpienia od Umowy
                  zgodnie z art. 38 ustawy z dnia 30 maja 2014 r. o prawach
                  konsumenta, ponieważ spełnianie świadczenia rozpoczyna się za
                  wyraźną zgodą Użytkownika przed upływem terminu do
                  odstąpienia.
                </p>

                <p className="terms-para">
                  12. Wyrażenie zgody na rozpoczęcie świadczenia przed upływem
                  terminu odstąpienia jest dobrowolne. Ze względu na charakter
                  Usług świadczonych „na żądanie”, Organizator może rozpocząć
                  świadczenie Usługi po uzyskaniu wyraźnej zgody Użytkownika.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  § 3 POZOSTAŁE ZASADY KORZYSTANIA Z USŁUG
                </h6>

                <p className="terms-para">
                  1. Możliwość skorzystania przez Użytkownika z Usługi
                  uzależniona jest od należytego spełnienia wymogów określonych
                  w niniejszym Regulaminie. W szczególności Użytkownik
                  zobowiązany jest zapewnić we własnym zakresie spełnienie
                  następujących minimalnych wymagań technicznych:
                </p>
                <ul>
                  <li>
                    <p className="terms-para">
                      a) telefon komórkowy wyposażony w aktywną kartę SIM w
                      sieci jednego z Operatorów, posiadający funkcjonalności
                      umożliwiające aktywację i korzystanie z Serwisu, w tym
                      odbieranie wiadomości SMS oraz brak blokad
                      uniemożliwiających korzystanie z Usługi Dostępowej;
                    </p>
                  </li>
                  <li>
                    <p className="terms-para">
                      b) połączenie z siecią Internet;
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p className="terms-para">
                      c) komputer, telefon lub inne urządzenie cyfrowe z
                      zainstalowanym oprogramowaniem umożliwiającym przeglądanie
                      stron internetowych (np. Internet Explorer, Google
                      Chrome), prawidłowo skonfigurowane, w szczególności w
                      zakresie transmisji danych;
                    </p>
                  </li>
                  <li>
                    {" "}
                    <p className="terms-para">
                      d) prawidłowa konfiguracja powyższych urządzeń, w
                      szczególności w zakresie transmisji danych.
                    </p>
                  </li>
                </ul>

                <p className="terms-para">
                  2. Użytkownik powinien być uprawniony do korzystania z
                  urządzeń, o których mowa powyżej, w zakresie umożliwiającym
                  korzystanie z Serwisu i Usługi.
                </p>

                <p className="terms-para">
                  3. Dodatkowe informacje dotyczące funkcjonalności oraz
                  interoperacyjności Usług, w tym kompatybilności z modelem
                  telefonu, oprogramowaniem komputera lub innego urządzenia, a
                  także ewentualne techniczne środki ochrony Usług, mogą być
                  podane w Serwisie przy wybranych Usługach.
                </p>

                <p className="terms-para">
                  4. Użytkownik zobowiązany jest do ochrony hasła oraz dostępu
                  do telefonu komórkowego, komputera lub konta umożliwiającego
                  korzystanie z Serwisu lub Usług przed nieuprawnionym użyciem
                  przez osoby trzecie.
                </p>

                <p className="terms-para">
                  5. Użytkownik uzyskujący dostęp do Usługi ma prawo korzystać z
                  niej wyłącznie w zakresie określonym niniejszym Regulaminem,
                  tj. wyłącznie w celu odtwarzania Usługi na telefonie,
                  komputerze lub innym przeznaczonym do tego urządzeniu. W
                  szczególności Użytkownik nie jest uprawniony do kopiowania,
                  zwielokrotniania, modyfikowania, prezentowania, publikowania
                  ani rozpowszechniania Usługi lub jej części w jakiejkolwiek
                  formie.
                </p>

                <p className="terms-para">
                  Korzystanie z Usługi dozwolone jest wyłącznie na użytek własny
                  Użytkownika (tj. osoby, na rzecz której świadczona jest
                  Usługa). Niedopuszczalne jest wykorzystywanie Usługi lub jej
                  części w celach komercyjnych, w tym w ramach działalności
                  gospodarczej, jej odsprzedaż lub udostępnianie osobom trzecim.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  § 4 OGRANICZENIA. PRAWA AUTORSKIE
                </h6>
                <p className="terms-para">
                  1. Mogą wystąpić krótkotrwałe przerwy w dostępie do Usługi,
                  nie dłuższe niż 5 godzin miesięcznie, spowodowane pracami
                  konserwacyjnymi lub technicznymi. W przypadku dłuższych przerw
                  Organizator dołoży starań, aby usunąć awarię w najkrótszym
                  możliwym czasie.
                </p>

                <p className="terms-para">
                  2. Usługa dostępna jest z wykorzystaniem transmisji danych,
                  podczas której mogą wystąpić okoliczności niezależne od
                  Organizatora, takie jak warunki pogodowe, nieprawidłowa
                  instalacja, niska jakość sygnału lub awarie sieci.
                </p>

                <p className="terms-para">
                  3. Usługa podlega ograniczeniom terytorialnym
                  (geolokalizacyjnym) i jest dostępna dla Użytkowników
                  logujących się z terytorium Rzeczypospolitej Polskiej lub
                  zweryfikowanych jako posiadających stałe miejsce zamieszkania
                  w Polsce.
                </p>

                <p className="terms-para">
                  4. Treści Usług mogą stanowić utwory chronione prawem
                  autorskim. Organizator może stosować systemy autoryzacji i
                  szyfrowania. Użytkownik może korzystać z Usług wyłącznie do
                  użytku osobistego i nie jest uprawniony do ich publicznego lub
                  komercyjnego udostępniania.
                </p>

                <p className="terms-para">
                  5. Usługi mogą podlegać ograniczeniom licencyjnym lub
                  technicznym, w tym sprzętowym. Informacje o takich
                  ograniczeniach dostępne są w Serwisie przy opisie danej
                  Usługi.
                </p>

                <p className="terms-para">
                  6. Ograniczenie dostępu do Usługi może nastąpić w przypadku
                  korzystania z niej jednocześnie na kilku urządzeniach lub
                  próby nieautoryzowanego dostępu do Konta Użytkownika.
                </p>

                <p className="terms-para">
                  7. Zabrania się dostarczania treści o charakterze bezprawnym.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">§ 5 ODPOWIEDZIALNOŚĆ</h6>

                <p className="terms-para">
                  1. Organizator ponosi odpowiedzialność za brak dostarczenia
                  Usługi w terminie oraz brak jej zgodności z Umową.
                </p>

                <p className="terms-para">
                  2. W przypadku niedostarczenia Usługi w terminie Użytkownik ma
                  prawo wezwać Organizatora do jej dostarczenia w trybie
                  reklamacyjnym. Jeżeli Usługa nie zostanie dostarczona,
                  Użytkownik może odstąpić od Umowy.
                </p>

                <p className="terms-para">
                  3. W przypadku świadczenia Usługi w sposób niezgodny z Umową,
                  Użytkownik może żądać doprowadzenia Usługi do zgodności z
                  Umową poprzez złożenie reklamacji.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">§ 6 REKLAMACJE</h6>

                <p className="terms-para">
                  1. Użytkownik ma prawo złożyć reklamację.
                </p>

                <p className="terms-para">
                  2. Reklamacje można składać drogą elektroniczną na adres
                  reklamacje@teleaudio.pl lub pisemnie na adres Organizatora.
                </p>

                <p className="terms-para">
                  3. Reklamacja powinna zawierać imię i nazwisko, numer MSISDN,
                  opis przedmiotu reklamacji, okres jej dotyczący oraz
                  okoliczności uzasadniające reklamację.
                </p>

                <p className="terms-para">
                  4. Reklamacja zostanie rozpatrzona nie później niż w ciągu 14
                  dni od jej otrzymania.
                </p>

                <p className="terms-para">
                  5. Odpowiedź na reklamację zostanie udzielona drogą
                  elektroniczną lub pisemną, zgodnie z formą zgłoszenia.
                </p>

                <p className="terms-para">
                  6. Organizator może wezwać Użytkownika do uzupełnienia
                  brakujących informacji. Brak współpracy może skutkować
                  pozostawieniem reklamacji bez rozpatrzenia.
                </p>

                <p className="terms-para">
                  7. Użytkownik ma prawo dochodzenia roszczeń na drodze sądowej
                  lub pozasądowej.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  § 7 POSTANOWIENIA KOŃCOWE. ZMIANY REGULAMINU
                </h6>

                <p className="terms-para">
                  1. Organizator jest uprawniony do wprowadzania zmian
                  Regulaminu.
                </p>

                <p className="terms-para">
                  2. Zmiany Regulaminu mogą wynikać m.in. ze zmian przepisów
                  prawa, wymogów administracyjnych, kwestii bezpieczeństwa,
                  rozwoju Usługi lub zmian technologicznych.
                </p>

                <p className="terms-para">
                  3. Informacja o zmianach Regulaminu będzie publikowana w
                  Serwisie z co najmniej 14-dniowym wyprzedzeniem, o ile jest to
                  możliwe.
                </p>

                <p className="terms-para">
                  4. W przypadku istotnych zmian negatywnie wpływających na
                  Usługę, Użytkownik może wypowiedzieć Umowę w terminie 30 dni.
                </p>

                <p className="terms-para">
                  5. W sprawach nieuregulowanych Regulaminem stosuje się
                  przepisy prawa polskiego.
                </p>

                <p className="terms-para">
                  6. Regulamin wchodzi w życie z dniem 21 maja 2025 r.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  WZÓR FORMULARZA ODSTĄPIENIA OD UMOWY
                </h6>
                <p className="terms-para">
                  (formularz ten należy wypełnić i odesłać tylko w przypadku
                  chęci odstąpienia od Umowy)  
                </p>

                <p className="terms-para">
                  Adresat: ……. Ja niniejszym informuję o moim odstąpieniu od
                  <br />
                  Umowy ……….. . Data zawarcia
                  <br />
                  umowy.............................. Imię i nazwisko
                  <br />
                  Użytkownika...................... Adres
                  <br />
                  Użytkownika................................ Podpis Użytkownika
                  <br />
                  (tylko jeżeli formularz jest przesyłany w wersji papierowej)
                  <br />
                  Data.....................  
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      );
    } else if (config.subDomain === "portal" && isGameverse) {
      return (
        <section className="terms">
          <Row>
            <Col xs="12">
              <div className="terms-title-wrap">
                <h6 className="terms-section-title">Bendrosios sąlygos ir privatumo politika</h6>
              </div>
            </Col>
          </Row>
          <Container fluid>
              <Col xs="12" className="terms-list">
                <p className="terms-para">
                  Šios Bendrosios sąlygos taikomos produktams ir paslaugoms,
                  teikiamoms per WAP, SMS, GPRS ir 3G, kuriuos teikia
                  „Mobimilia BV“ arba jos susijusios įmonės (toliau –
                  „Tiekėjas“). Tiekėjas turi teisę retkarčiais keisti šias
                  Bendrąsias sąlygas be išankstinio įspėjimo. Be Bendrųjų
                  sąlygų, jums ir Tiekėjui, naudojantis Tiekėjo Paslaugomis
                  (kaip apibrėžta toliau), taip pat taikomos visos taikomos ir
                  viešai paskelbtos taisyklės, akcijų sąlygos, gairės ir
                  nuostatos, susijusios su paslaugomis. Visos tokios gairės,
                  taisyklės, akcijų sąlygos ir nuostatos laikomos neatskiriama
                  šių Bendrųjų sąlygų dalimi. Naudodamiesi Tiekėjo
                  Paslaugomis, jūs sutinkate laikytis šių Bendrųjų sąlygų,
                  gairių, taisyklių ir akcijų sąlygų.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Tiekėjo aprašymas</h6>

                <p className="terms-para">
                  Naudodamas WAP, SMS, GPRS ir 3G paslaugas, Tiekėjas
                  suteikia vartotojams prieigą prie internetinių išteklių
                  tinklo, įskaitant internetinius žaidimus, tekstinius
                  pranešimus, turtingą turinį ir internetinę informaciją, kurią
                  galima atsisiųsti į mobilųjį telefoną ar kitus įrenginius
                  (toliau – „Paslaugos“). Bendrosios sąlygos visada taikomos
                  visoms naujoms funkcijoms, įskaitant funkcijas, kurias
                  Tiekėjas gali įgyvendinti plėtodamas, išplėsdamas ar
                  tobulindamas savo paslaugas, taip pat bet kokioms naujoms
                  funkcijoms, kurias Tiekėjas prideda.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Prieinamumas</h6>

                <p className="terms-para">
                  Paslauga teikiama tokia, kokia yra (dabartiniame jos
                  vystymosi etape), ir Tiekėjas neprisiima jokios
                  atsakomybės bei nesuteikia jokių garantijų ar užtikrinimų
                  tuo atveju, jei asmeniniai nustatymai, informacija ar
                  pranešimai nebus išsaugoti, nebus išsaugoti laiku, bus
                  ištrinti arba pateikti neteisingai. Norėdami užsisakyti
                  Paslaugą, turite turėti prieigą prie interneto ir (arba)
                  mobiliojo ryšio abonementą bei sumokėti visus su tokia
                  prieiga susijusius mokesčius. Turite padengti visas
                  išlaidas, susijusias su tokios prieigos sukūrimu. Taip pat
                  esate atsakingi už bet kokios reikalingos įrangos, įskaitant
                  mobilųjį telefoną, asmeninį kompiuterį ar kitus įrenginius,
                  kurie gali būti reikalingi ir tinkami naudoti su Paslauga,
                  prijungimą.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Mokėjimas</h6>
                <p className="terms-para">
                  Prieigą prie mūsų internetinių paslaugų turite nemokamai.
                  Naudodamiesi Paslaugomis, privalote mokėti sumą, atitinkančią
                  tuo metu galiojančius Tiekėjo tarifus ir jūsų mobiliojo
                  ryšio operatoriaus taikomus tarifus. Mokesčiai bus
                  įtraukiami į jūsų mobiliojo ryšio operatoriaus sąskaitą,
                  kurią gausite iš savo tinklo mobiliojo ryšio operatoriaus.
                  Jūs mokate Tiekėjui visus nacionalinius, vietinius ar kitus
                  mokesčius, įskaitant, bet neapsiribojant, PVM, bet kokius
                  mokesčius ar rinkliavas, taikomas Paslaugų naudojimo
                  išlaidoms, nepriklausomai nuo to, ar šiuos mokesčius dabar
                  ar ateityje nustato Europos, nacionalinės ar vietinės
                  valdžios institucijos, ar bet kuris kitas įgaliotas mokesčius
                  renkantis subjektas. Tiekėjas pasilieka teisę keisti
                  Paslaugų tarifus, paskelbdamas informaciją apie tokius
                  pakeitimus savo svetainėje.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Registracijos įsipareigojimas</h6>

                <p className="terms-para">
                  Siekiant užtikrinti saugų ir patikimą Paslaugos naudojimą,
                  be taikomų mokesčių sumokėjimo, jūs garantuojate, kad: (a)
                  jūsų asmeninė informacija (toliau – „Registracijos
                  informacija“), pateikta registracijos formoje, yra teisinga,
                  tiksli ir išsami; ir (b) jūs sutinkate užtikrinti, kad
                  Registracijos informacija visada būtų teisinga, tiksli ir
                  išsami. Jei Tiekėjas turi pagrįstą priežastį įtarti, kad
                  Registracijos informacija yra neteisinga, netiksli ar
                  neišsami, Tiekėjas turi teisę sustabdyti ar nutraukti jūsų
                  paskyrą bei uždrausti tiek dabartinį, tiek būsimą Paslaugos
                  ar jos sudedamųjų dalių naudojimą. Jūs esate atsakingi už
                  bet kokių slaptažodžių ir (arba) paskyrų, kuriuos jums
                  suteikė Tiekėjas, konfidencialumo išlaikymą ir esate
                  visiškai atsakingi už visą veiklą, vykdomą naudojant jūsų
                  slaptažodį ar paskyrą. Jūs įsipareigojate uždaryti savo
                  paskyrą kiekvienos sesijos pabaigoje (uždarydami naršyklę)
                  ir susisiekti su Tiekėju, jei pastebite ar įtariate, kad
                  jūsų slaptažodis ar paskyra buvo panaudoti neteisėtai arba
                  kad dėl bet kokios kitos priežasties saugumas ar apsauga
                  nebėra užtikrinti. Tiekėjas negali ir neatsakys už jokią
                  žalą, atsiradusią dėl to, kad nesilaikėte šio straipsnio
                  nuostatų.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Tiekėjo nuosavybės teisės</h6>

                <p>
                  Šios Bendrosios sąlygos taikomos produktams ir paslaugoms,
                  teikiamoms per WAP, SMS, GPRS ir 3G, kuriuos teikia
                  „Mobimilia BV“ arba jos susijusios įmonės (toliau –
                  „Tiekėjas“). Tiekėjas turi teisę retkarčiais keisti šias
                  Bendrąsias sąlygas be išankstinio įspėjimo. Be Bendrųjų
                  sąlygų, jums ir Tiekėjui, naudojantis Tiekėjo Paslaugomis
                  (kaip apibrėžta toliau), taip pat taikomos visos taikomos ir
                  viešai paskelbtos taisyklės, akcijų sąlygos, gairės ir
                  nuostatos, susijusios su paslaugomis. Visos tokios gairės,
                  taisyklės, akcijų sąlygos ir nuostatos laikomos neatskiriama
                  šių Bendrųjų sąlygų dalimi. Naudodamiesi Tiekėjo
                  Paslaugomis, jūs sutinkate laikytis šių Bendrųjų sąlygų,
                  gairių, taisyklių ir akcijų sąlygų.
                </p>
              </Col>
          </Container>
        </section>
      );
    } else if (config.subDomain === "bg" && isPlaynixzone) {
      return (
        <section className="terms">
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6
                  className="terms-section-title"
                  style={{ marginBottom: "20px" }}
                >
                  Общи условия
                </h6>

                <p className="terms-para">
                  Следните Общи условия се отнасят за продуктите и услугите,
                  предоставяни чрез WAP, SMS, GPRS и 3G от Mobimilia. или
                  нейните свързани компании (наричани по-долу „Доставчик“).
                  Доставчикът може да променя тези Общи условия периодично без
                  предварително уведомление. В допълнение към Общите условия,
                  всички правила, промоционални условия, насоки и приложими
                  разпоредби, публикувани във връзка с Услугите, се отнасят и за
                  вас и Доставчика, когато използвате Услугите (както са
                  дефинирани в този документ). Всички такива насоки, правила,
                  промоционални условия и разпоредби се считат за неразделна
                  част от настоящите Общи условия. С използването на Услугите на
                  Доставчика, вие се съгласявате да бъдете обвързани с
                  настоящите Общи условия, както и с приложимите насоки, правила
                  и промоционални условия.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Описание на Доставчика.</h6>

                <p className="terms-para">
                  Чрез WAP, SMS, GPRS и 3G услуги, Доставчикът предоставя на
                  своите потребители достъп до мрежа от онлайн ресурси,
                  включително онлайн игри, текстови съобщения, мултимедийно
                  съдържание и онлайн информационни материали, които могат да
                  бъдат изтеглени на мобилни телефони или други устройства
                  („Услуги“). Общите условия винаги се прилагат за всички нови
                  функции, включително тези, които Доставчикът може да внедри
                  като част от разширяването, надграждането или подобряването на
                  текущите Услуги, включително разширения на нови функции,
                  добавени от Доставчика.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Наличност.</h6>

                <p className="terms-para">
                  Услугата се предоставя в състоянието, в което се намира, и
                  Доставчикът не поема отговорност и не предлага гаранции в
                  случай на лични настройки, информация или съобщения, които не
                  са запазени, не са запазени навреме или са изтрити или
                  доставени неправилно. За да се абонирате за Услугата, трябва
                  да имате достъп до интернет и/или мобилен абонамент и да
                  заплатите всички такси, свързани с такъв достъп. Вие носите
                  отговорност за всички разходи, направени за предоставянето на
                  такъв достъп. Вие също така носите отговорност за свързването
                  на необходимото оборудване, включително мобилен телефон,
                  персонален компютър или друго устройство, което може да е
                  необходимо и в добро работно състояние, за да използвате
                  Услугата.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Плащане.</h6>
                <p className="terms-para">
                  Имате безплатен достъп до нашите онлайн услуги. Във връзка с
                  Услугите и тяхното използване, вие носите задължение да
                  заплатите съответната такса съгласно актуалните тарифи на
                  Доставчика, както и съгласно тарифите, начислявани от вашия
                  мобилен оператор. Таксите ще бъдат фактурирани чрез вашия
                  мобилен оператор във вашата телефонна сметка. Вие плащате на
                  Доставчика всички национални и местни данъци или други такси,
                  включително, но не само, ДДС или други данъци и такси,
                  налагани сега или в бъдеще от европейски, национални или
                  местни власти или други упълномощени органи, свързани с
                  разходите за ползване на Услугите. Доставчикът си запазва
                  правото да променя тарифите за Услугите, като публикува
                  подробности за тези промени на своя уебсайт.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Изискване за регистрация.</h6>

                <p className="terms-para">
                  За да осигурите безопасното и сигурно ползване на Услугата,
                  Вие гарантирате следното, в допълнение към плащането на
                  приложимите такси: (а) Вашата лична информация („Информация за
                  регистрация“) във формуляра за регистрация е вярна, точна и
                  пълна и (б) Вие се съгласявате да осигурите, че Информацията
                  за регистрация остава вярна, точна и пълна по всяко време. Ако
                  Доставчикът има основателни причини да подозира, че
                  Информацията за регистрация не е точна или пълна, Доставчикът
                  има право да спре или прекрати Вашия акаунт и да ограничи
                  използването на Услугата от Ваша страна. Вие носите
                  отговорност за поверителността на всяка парола и/или акаунт,
                  издадени от Доставчика, и носите пълна отговорност за всички
                  действия, предприети съгласно тях. Вие се съгласявате да
                  затваряте акаунта си в края на всяка сесия и да уведомявате
                  Доставчика, ако забележите или подозирате неоторизирано
                  ползване. Доставчикът не носи отговорност за каквито и да е
                  щети, произтичащи от неспазването на тези задължения от ваша
                  страна.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Права на собственост на Доставчика.
                </h6>

                <p>
                  Следните Общи условия се прилагат за продуктите и услугите,
                  предоставяни чрез WAP, SMS, GPRS и 3G от Mobimilia. или
                  нейните свързани дружества (наричани по-долу „Доставчик“).
                  Доставчикът може да променя Общите условия без предварително
                  уведомление. В допълнение към Общите условия, всички правила,
                  промоционални условия, насоки и разпоредби, публикувани във
                  връзка с услугите, също се прилагат и се считат за част от
                  Общите условия. С използването на Услугите на Доставчика, вие
                  се съгласявате да бъдете обвързани с тези общи условия и
                  приложимите правила.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      );
    } else
      return (
        <section className="terms">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="terms-title-wrap">
                  <h2 className="terms-section-title">
                    <FormattedMessage
                      id="terms-condition-title"
                      defaultMessage="Terms and Conditions"
                    />
                  </h2>
                </div>
              </Col>
            </Row>
            <Row className="no-gutters">
              {config.subDomain === "my" && (isGamiclub || isGamelords) && (
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Owner and Data Controller</h6>
                  <p className="terms-para">
                    <strong>Owner and Data Controller Name</strong>: Sam Media
                    Sdn Bhd
                  </p>
                  <p className="terms-para">
                    <strong>Address:</strong> Suite 2, Level 11, Menara Ilham,
                    NO. 8 Jln Binjai, 50450 KL
                  </p>
                  <p className="terms-para">
                    <strong>Owner contact email:</strong> mycs@content-clubs.com
                  </p>
                </Col>
              )}
              {config.subDomain === "lt" && isTheGamingClubs && (
                <Col xs="12" className="terms-list">
                  <p className="terms-para">Noteikumi un Nosacījumi</p>
                  <p className="terms-para">NAUDOJIMOSI SĄLYGOS</p>
                  <p className="terms-para">
                    „Gamingclub“ – tai aukščiausios kokybės SMS paslauga,
                    prieinama Telia, „Bitės“ ir „Tele2“ GSM tinklo naudotojams.
                  </p>
                  <p className="terms-para">
                    Šią paslaugą teikia „Sam Media“ (Prizeflix B.V. pagrindinė
                    įmonė), Van Diemenstraat 356, 1013CR - Amsterdamas,
                    Olandija.
                  </p>
                  <p className="terms-para">
                    Kai patvirtinate paslaugą, nukreipimo puslapyje įvesdami
                    unikalų PIN numerį arba raktažodį siųsdami SMS žinute,
                    sutinkate su paslaugos naudojimosi sąlygomis ir
                    prisijungiate prie „Gamingclub“ paslaugos. Gausite unikalią
                    nuorodą, per kurią bus galima pasiekti paslaugą. „Telia“ ir
                    „Bitė“ vartotojams: „Bitė“ vartotojams: kiekvieną savaitę
                    būsite apmokestinti 3,9 EUR, o prenumerata bus automatiškai
                    atnaujinta. „Tele 2“ ir „Telia“ vartotojams: būsite
                    apmokestinti 7 EUR už pranešimą ir galėsite naudotis
                    paslauga dvi savaites.
                  </p>
                  <p className="terms-para">
                    Šie mokesčiai bus mokami iš jūsų išankstinio mokėjimo
                    balanso prenumeratos pradžioje ir vėliau kas savaitę arba
                    bus pridėti prie jūsų mėnesinės mobiliojo telefono sąskaitos
                    už šį telefoną. Tekstinių pranešimų siuntimo mokestis
                    taikomas pagal standartinius operatoriaus tarifus. Pagal
                    jūsų planą gali būti taikomi operatoriaus duomenų mokesčiai.
                  </p>
                  <p className="terms-para">
                    Paslaugos galite atsisakyti siųsdami SMS žinutę STOP GAMING
                    numeriu 1335.
                  </p>
                  <p className="terms-para">
                    Paslaugos prenumeratorius privalo būti mobiliojo telefono
                    savininkas arba turi gauti atitinkamą savininko leidimą dar
                    prieš prisijungiant prie paslaugos. Prie paslaugos jungtis
                    norintys vaikai iki 18 metų privalo gauti tėvų arba globėjų
                    sutikimą.
                  </p>
                  <p className="terms-para">
                    Nei vienas iš išvardytų produktų ar perpardavėjų jokiu būdu
                    nėra susijęs su „Gamingclub“, jis neremia bei papildomai
                    neskatina naudotis „Gamingclub“.
                  </p>
                  <h6 className="terms-title">Galutinės sąlygos</h6>
                  <p className="terms-para">Galutinės sąlygos</p>
                </Col>
              )}
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  <FormattedMessage
                    id="gen-terms-condition-title"
                    defaultMessage="General Terms And Conditions And Privacy Policy."
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="gen-terms-condition-desc"
                    defaultMessage="The following General Terms and Conditions are applicable to the products and services supplied via WAP, SMS, GPRS and 3G by Sam Media Ltd., or enterprises affiliated to it, (hereinafter to be referred to as “the Provider”). The Provider is permitted to amend these General Terms and Conditions from time to time without notice. Apart from the General Terms and Conditions, any applicable and publicized rules, promotional conditions, guidelines and provisions pertaining to the services also apply to you and the Provider upon the use of the Services (as defined herein) of the Provider. All those guidelines, rules, promotional conditions and provisions will be considered an inextricable part of these General Terms and Conditions. By availing yourself to use the Services of the Provider, you agree to be bound by these General Terms and Conditions and the guidelines, rules and promotional conditions."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  <FormattedMessage
                    id="provider-terms-condition-title"
                    defaultMessage="Description Of The Provider."
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="provider-terms-condition-desc"
                    defaultMessage="By means of WAP, SMS, GPRS and 3G services, the Provider supplies its user’s access to a network of on-line sources, including on-line games, text messages, rich content and on-line information material which may be downloaded onto mobile telephone or whatsoever devices (“Services”). The General Terms and Conditions are at all times applicable to all new facilities including facilities which the Provider may implement as part of the Provider’s expansion, extension or improvement of the present Services, including any extension to new functions added by the Provider."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  <FormattedMessage
                    id="availability-terms-condition-title"
                    defaultMessage="Availability."
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="availability-terms-condition-desc"
                    defaultMessage="The Service is supplied as is (at the stage of development it happens to be in) and the Provider accepts no liability nor does it issue any guarantees or warranty in the event that personal configurations, information or messages are not saved, or not saved in due time, or if they are deleted or incorrectly delivered. In order to subscribe to the Service, you are required to have access to the Internet and/or a mobile communications subscription and pay any service fees associated with such access. You are required to pay all expenses incurred in creating such access. You are also responsible for seeing to the connection of any necessary equipment, including any mobile telephone or personal computer or whatever devices that may be necessary needed and are in working order and suitable for use in connection with the Service."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  <FormattedMessage
                    id="payment-terms-condition-title"
                    defaultMessage="Payment."
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="payment-terms-condition-desc"
                    defaultMessage="You have access to our on-line services free of charge. With regards to the Services and the use of it, you shall pay the amount corresponding to the applicable rates of the Provider in force at that time and according to the rates charged by your mobile operator. The charges shall be invoiced to you via your mobile operator through the mobile bill you receive from the mobile operator of your network. You pay the Provider all national and local or other taxes, including but not restricted to VAT, any taxes or levies imposed in lieu thereof, which taxes are based on the costs due to the use of the Services, regardless of whether those taxes are levied either now or in the future by European, national or local authorities or by any other body or bodies authorized to levy taxes. The Provider reserves the right to change the rates for the Service by posting details of such changes on its website."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  <FormattedMessage
                    id="obligation-terms-condition-title"
                    defaultMessage="Registration Obligation."
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="obligation-terms-condition-desc"
                    defaultMessage="In order to warrant safe and secure use of the Service, you guarantee the following, in addition to paying the applicable charges: (a) your personal information (hereinafter to be referred to as the “Registered Information”) provided on the registration form is correct, true, accurate and complete and (b) you agree to ensure that the Registered Information is at all times correct, up to date, true, accurate and complete. If the Provider has a reasonable suspicion that the Registered Information does not reflect a true state of affairs, or is not accurate or complete, then the Provider is entitled to suspend or terminate your account and to withhold both current and future use of the Service, or any component of it. You yourself are responsible for maintaining the secrecy of any passwords and/or accounts issued to you by the Provider, and you are fully liable for all actions carried out involving the use of your password or account. You undertake at the end of each session to close your account (by closing your browser) and to contact the Provider if you notice or suspect that unauthorized use has been made of your password or account, or that security or protection is no longer guaranteed for any other reason. The Provider cannot and will not be liable for any damage arising from your failure to observe the stipulations of this article."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  <FormattedMessage
                    id="ownership-terms-condition-title"
                    defaultMessage="Ownership Rights Of The Provider."
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="ownership-terms-condition-desc"
                    defaultMessage="The following General Terms and Conditions are applicable to the products and services supplied via WAP, SMS, GPRS and 3G by Sam Media Ltd., or enterprises affiliated to it, (hereinafter to be referred to as “the Provider”). The Provider is permitted to amend these General Terms and Conditions from time to time without notice. Apart from the General Terms and Conditions, any applicable and publicized rules, promotional conditions, guidelines and provisions pertaining to the services also apply to you and the Provider upon the use of the Services (as defined herein) of the Provider. All those guidelines, rules, promotional conditions and provisions will be considered an inextricable part of these General Terms and Conditions. By availing yourself to use the Services of the Provider, you agree to be bound by these General Terms and Conditions and the guidelines, rules and promotional conditions."
                  />
                </p>
              </Col>
              {config.subDomain === "pt" && isGamelords && (
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Como cancelar?</h6>
                  <p className="terms-para">
                    Após confirmar a aceitação do pagamento do serviço, o
                    utilizador poderá aceder ou visualizar todos os produtos que
                    estejam disponíveis dentro da serviço que subscreveu. O
                    serviço permanecerá activo até que o próprio utilizador
                    solicite o cancelamento do mesmo. Poderá fazê-lo de forma
                    gratuita em qualquer momento bastando para isso utilizar
                    qualquer uma das ferramentas disponíveis para o efeito:
                  </p>
                  <p className="terms-para">
                    Enviar a keyword ´SAIR´ para o 62947.
                  </p>
                  <p className="terms-para">
                    Através do serviço de apoio ao cliente:
                  </p>
                  <p className="terms-para">
                    Horário de atendimento telefónico: dias úteis (excepto
                    feriados) das 09h00 às 18h00.
                  </p>
                  <p className="terms-para">Linha de Apoio ao Cliente:</p>
                  <p className="terms-para">Gamelords - 707 450 201</p>
                </Col>
              )}
            </Row>
          </Container>
        </section>
      );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms/Terms.js